var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 13.7143V1.07143C33.9913 1.32143 34.2569 1.57143 34.4635 1.82143L43.4948 12.75C43.7014 13 43.908 13.3214 44.1146 13.7143H33.6667ZM30.8333 14.5714C30.8333 15.2857 31.0399 15.8929 31.4531 16.3929C31.8663 16.8929 32.3681 17.1429 32.9583 17.1429H45V45.4286C45 46.1429 44.7934 46.75 44.3802 47.25C43.967 47.75 43.4653 48 42.875 48H13.125C12.5347 48 12.033 47.75 11.6198 47.25C11.2066 46.75 11 46.1429 11 45.4286V2.57143C11 1.85714 11.2066 1.25 11.6198 0.75C12.033 0.25 12.5347 0 13.125 0H30.8333V14.5714Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.05,
    x1: 19,
    y1: 29,
    x2: 39,
    y2: 29,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.05,
    x1: 19,
    y1: 33,
    x2: 39,
    y2: 33,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.05,
    x1: 19,
    y1: 37,
    x2: 39,
    y2: 37,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.05,
    x1: 19,
    y1: 41,
    x2: 34,
    y2: 41,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4211 33.1053C25.4211 33.7194 25.1771 34.3085 24.7428 34.7428C24.3085 35.1771 23.7194 35.4211 23.1053 35.4211H6.89474C6.28055 35.4211 5.69152 35.1771 5.25723 34.7428C4.82293 34.3085 4.57895 33.7194 4.57895 33.1053V16.8947C4.57895 16.2806 4.82293 15.6915 5.25723 15.2572C5.69152 14.8229 6.28055 14.5789 6.89474 14.5789H23.1053C23.7194 14.5789 24.3085 14.8229 24.7428 15.2572C25.1771 15.6915 25.4211 16.2806 25.4211 16.8947V33.1053Z",
    fill: "#3B88C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06727 20.2746C7.01342 20.0413 6.99548 19.9157 6.99548 19.6644C6.99548 19.0901 7.48005 18.4793 8.26974 18.4793C9.13121 18.4793 9.54458 18.9824 9.70611 19.7721L11.2316 27.4009H11.2675L13.6013 19.5388C13.7987 18.8927 14.3377 18.4793 15.0017 18.4793C15.6658 18.4793 16.2042 18.8927 16.4022 19.5388L18.7354 27.4009H18.7707L20.2974 19.7721C20.4577 18.9824 20.8717 18.4793 21.7337 18.4793C22.5228 18.4793 23.008 19.0901 23.008 19.6644C23.008 19.9157 22.9895 20.0413 22.9356 20.2746L20.6557 30.0756C20.4763 30.83 19.8834 31.4755 18.879 31.4755C18.4805 31.4804 18.0914 31.3551 17.7707 31.1186C17.45 30.8822 17.2152 30.5475 17.1022 30.1654L15.0191 23.2365H14.9838L12.9013 30.1654C12.788 30.5474 12.5531 30.882 12.2323 31.1185C11.9116 31.3549 11.5224 31.4803 11.1239 31.4755C10.1189 31.4755 9.52663 30.83 9.34716 30.0756L7.06727 20.2746Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2",
    x: 0,
    y: 0,
    width: 49,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.9558166bdb5ea4aaf2ce23868e2c60b3.svg";
export { ForwardRef as ReactComponent };